export default "__VITE_PUBLIC_ASSET__dde58b28__"